<template>
  <div
    class="more-service"
    v-if="expandServices.length"
  >
    <p class="more-service__title">
      More Services
    </p>
    <div class="more-service__content">
      <div
        v-for="service of expandServices"
        class="more-service-item"
        :class="{
          'more-service-item--active': service.quantity === 1,
        }"
        @click="service.quantity = service.quantity === 1 ? 0 : 1"
      >
        <Image
          class="more-service-item__image"
          :src="service.skuImageUrl"
        />
        <div class="more-service-item__content">
          <p class="more-service-item__title">
            {{ service.tag }}
            <template v-if="service.canUseMoq > 1">
              (MOQ>={{ service.canUseMoq }})
            </template>
          </p>
          <p class="more-service-item__content">
            <IntlCurrency
              :currency="currency.current.targetCurrency"
            />
            {{ bankersRoundWithMax(service.price * currency.current.rate, 0.01) }}
          </p>
        </div>
        <img
          class="more-service-item__icon"
          :src="service.quantity === 1 ? SelectedImage : UnSelectImage"
        >
      </div>
    </div>
  </div>
</template>

<script setup>
import { Image } from '@/components/Image'
import UnSelectImage from '@/assets/offer/unselect.svg'
import SelectedImage from '@/assets/offer/selected.svg'
import { IntlCurrency } from '@/components/NewIntlCurrency'
import { useCurrencyStore } from '@/pinia/currency'
import { useProductDetail } from '@/views/OfferView/components/hooks/useProductDetail'
import { bankersRoundWithMax } from '@/utils/utils'

const { expandServices } = useProductDetail()

const currency = useCurrencyStore()
</script>

<style lang="less" scoped>
.more-service {
  padding: 16px 12px;
  border-radius: 16px;
  border: 1px solid #EBF1F5;

  &__title {
    font-family: mon-700;
    font-size: 14px;
    line-height: 18px;
  }

  &__content {
    margin-top: 12px;
  }

  &-item {
    display: flex;
    align-items: center;
    padding: 12px;
    gap: 8px;
    border-radius: 8px;
    border: 1.5px solid #F8F8F8;
    background: #F8F8F8;
    cursor: pointer;

    &--active {
      border-color: #1B3E9C;
      background: #EFF4FD;
    }

    &--disabled {
      opacity: .6;
      pointer-events: none;
    }

    &__image {
      width: 36px;
      height: 36px;
      border-radius: 4px;
    }

    &__title {
      font-family: mon-500;
      font-size: 12px;
      line-height: 16px;
      color: #232323;
    }

    &__content {
      margin-top: 4px;
      font-family: mon-600;
      font-size: 12px;
      line-height: 16px;
      color: #232323;
    }

    &__icon {
      margin-left: auto;
    }

    + .more-service-item {
      margin-top: 8px;
    }
  }
}
</style>
